import React, { useEffect, useState } from "react";
import "./mcqQuestion.css";
import AttachmentDefault from "../../Create_Assessment/Create_Question/Create_Q_Type/AttachmentDefault";
import ZoomableImage from "../../../../Components/zoomablePic";
import { Box, Paper, Typography, Stack, Chip, Divider } from "@mui/material";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";
import MideaViewer from "../../../../midea_viewer/MideaViewer";

const McqQuestion = ({
  response,
  questionNumber,
  setResponseAnswers,
  studentResults,
}) => {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isRightAnswer, setIsRightAnswer] = useState(false);
  const [inputValue, setInputValue] = useState({
    remark: "",
    score: "",
  });

  const { remark, score } = inputValue;

  // const checkCorrectAnswer = () => {
  //   console.log("response?.question?.correct_answers", response?.question?.correct_answers);
  //   console.log("key>>>>>>>>>>", key);
  //   const key = response.answer.key;
  //   const correctAnswer = response?.question?.correct_answers;

  //   if (Array.isArray(correctAnswer) && correctAnswer.length > 0) {
  //     // Check if any correct answer matches the given key
  //     const isKeyCorrect = correctAnswer.some(answer => answer.option_key === key);
  //     if (!isKeyCorrect) {
  //       setIsRightAnswer(true)
  //     } else {
  //       setIsRightAnswer(false)
  //     }
  //     // console.log("isCorrect", isCorrect);
  //     // setIsRightAnswer(isCorrect) // Uncomment if needed
  //     return false;
  //   }

  //   // Default to false if there are no correct answers or other issues
  //   return false;
  // };

  useEffect(() => {
    // if(response.answer.key !== response.question.correct_answers[0].option_key){
    //   setIsRightAnswer(true)
    // }
    if (response && response.answer && response.question) {
      const key = response.answer.key;
      const correctAnswer = response.question.correct_answers;

      if (Array.isArray(correctAnswer) && correctAnswer.length > 0) {
        const isKeyCorrect = correctAnswer.some(
          (answer) => answer.option_key === key
        );
        if (!isKeyCorrect) {
          setIsRightAnswer(true);
        } else {
          setIsRightAnswer(false);
        }
      } else {
      }
    } else {
    }
  }, [response]);

  const checkCorrectAnswer = (key) => {
    if (response?.question?.correct_answers?.length > 0) {
      return response?.question?.correct_answers?.find(
        (answer) => answer.option_key === key
      );
    }
  };

  const checkStudentAnswer = (option_key) => {
    if (response?.answer) {
      const isCorrect = response?.answer?.key === option_key;
      return isCorrect;
    }
  };

  const matchResultWithResponse = () => {
    let result = studentResults.find(
      (result) => result?.question_response?.id === response?.id
    );
    return result;
  };

  useEffect(() => {
    !studentResults?.length > 0 &&
      setInputValue({
        remark: response?.result?.remark,
        score: response?.result?.score ? response?.result?.score : "",
      });
    const resultInitialization = () => {
      setResponseAnswers((prevState) =>
        prevState.map((responseData) =>
          responseData.id === response.id
            ? {
              ...responseData,
              result: {
                ...responseData.result,
                questionResponse: response.id,
                correctScore: response?.question?.correct_score,
                // score: response?.question?.correct_answers.length == 1 && checkStudentAnswer(response?.question?.correct_answers[0]?.option_key) ? response?.question?.correct_score : "0",
                score: response?.question?.correct_answers?.some(
                  (correctAnswer) =>
                    checkStudentAnswer(correctAnswer?.option_key)
                )
                  ? response?.question?.correct_score
                  : "0",
              },
            }
            : responseData
        )
      );
    };
    (!response?.result?.questionResponse || !response?.result?.correctScore) &&
      !studentResults?.length > 0 &&
      resultInitialization();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const handleSubmitRemark = (e) => {
    setResponseAnswers((prevState) =>
      prevState.map((responseData) =>
        responseData.id === response.id
          ? {
            ...responseData,
            result: { ...responseData.result, remark: e.target.value.trim() },
          }
          : responseData
      )
    );
  };

  const handleSubmitScore = (e) => {
    setResponseAnswers((prevState) =>
      prevState.map((responseData) =>
        responseData.id === response.id
          ? {
            ...responseData,
            result: { ...responseData.result, score: e.target.value },
          }
          : responseData
      )
    );
  };

  const handleClickforpdf = (attachment) => {
    setTimeout(() => {
      setResponseAttach(attachment)
      setMideaviewer(true);
    }, 100);
  };
  return (
    // <div className="onreview_type_questions_hw mt-4 ">
    //   <div className="col-md-12 d-flex ">
    //     <div className="review_question_no_hw">Q{questionNumber + 1}.</div>
    //     <div className="review_question_hw p-0 m-0 col-md-9 col-lg-11">
    //       {response?.question?.title?.split("\n").map((line, index) => (
    //         <React.Fragment key={index}>
    //           {index !== 0 && <br />}
    //           <span >
    //             {line}
    //           </span>
    //         </React.Fragment>
    //       ))}
    //       {" "} <span style={{ color: "brown" }}>{response?.question?.is_mandatory === "true" && "*mandatory"}</span>
    //     </div>
    //   </div>
    //   <div style={{ display: "flex", gap: "10px", }}>
    //     {response?.question?.attachments.length > 0 &&
    //       response?.question?.attachments.map((obj, index) => (
    //         <div style={{ margin: "15px 42px" }}>
    //           <AttachmentDefault attach={obj} className={"ansAttach"} fileSize={response?.question?.attachments_sizeKb[index]} />
    //         </div>
    //       ))}
    //   </div>
    //   <div className=" col-lg-7 col-md-10 p-1">
    //     {response?.question?.options.length > 0 &&
    //       response?.question?.options.map((option, index) => {
    //         return (
    //           <>
    //             <div
    //               key={index}
    //               className={`my-2 options__box_hw ${checkCorrectAnswer(option?.key) && `options__box_right_hw`
    //                 } ${checkStudentAnswer(option?.key) &&
    //                 !checkCorrectAnswer(option?.key) &&
    //                 `options__box_wrong_hw`
    //                 }`}
    //             >
    //               {
    //                 option?.key + ". "
    //               }
    //               <input
    //                 readOnly
    //                 checked={
    //                   checkCorrectAnswer(option?.key)
    //                     ? true
    //                     : false || checkStudentAnswer(option?.key)
    //                       ? true
    //                       : false
    //                 }
    //                 type="checkbox"
    //                 className={`${checkCorrectAnswer(option?.key)
    //                   ? `response_green_checkbox ml-2`
    //                   : `response_red_checkbox ml-2`
    //                   }`}
    //               />
    //               <div className="col Right_optionA_hw">
    //                 <span className="question_options_hw">{option?.value}</span>

    //                 {checkCorrectAnswer(option?.key) && (
    //                   <span className="right_Answer_hw">Correct Answer</span>
    //                 )}

    //                 {checkStudentAnswer(option?.key) && (
    //                   <span
    //                     className={`${checkCorrectAnswer(option?.key)
    //                       ? `right_Answer_hw`
    //                       : `wrong_Answer_hw`
    //                       }`}
    //                   >
    //                     Student Answer
    //                   </span>
    //                 )}
    //               </div>
    //             </div>
    //             <div style={{ marginLeft: "30px" }}>
    //               {option.attachment &&
    //                 (() => {
    //                   const ext = option.attachment.split(".").pop().toLowerCase();
    //                   const isImage = ["jpg", "jpeg", "png"].includes(ext);
    //                   return isImage ? (
    //                     <ZoomableImage src={option.attachment} />
    //                   ) : null;
    //                 })()}
    //             </div>
    //           </>
    //         )
    //       })}
    //   </div>

    //   {response?.answer?.key === " " ? (
    //     <div className="d-flex ml-2">
    //       <img src="/images/wrong_icon.svg" alt="" />
    //       <div className="m-2 review_wrong_header_hw">Student Not Answered</div>
    //     </div>
    //   ) : (
    //     isRightAnswer && (
    //       <div className="d-flex align-items-center">
    //         <img src="/images/wrong_icon.svg" alt="" />
    //         <div className="m-2 review_wrong_header_hw">Wrong</div>
    //       </div>
    //     )
    //   )}

    //   <div className="">
    //     <div className="col-sm-6 mt-3 mb-1 review_remark_header_hw">Teacher Comment:</div>
    //     <div style={{ width: "96%" }}>
    //       <textarea
    //         onBlur={(e) => handleSubmitRemark(e)}
    //         onChange={(e) =>
    //           setInputValue((prev) => ({ ...prev, remark: e.target.value }))
    //         }
    //         readOnly={studentResults?.length > 0}
    //         type="text"
    //         maxLength={250}
    //         placeholder="Type Remark here........."
    //         className="remark_textfield_box_hw"
    //         value={
    //           studentResults?.length > 0
    //             ? matchResultWithResponse()?.comment
    //             : remark
    //         }
    //       />
    //       <div className="alot_no_field_hw my-3 ">
    //         <div className="allot_marks_hw">
    //           Allot marks out of {response?.question?.correct_score}
    //         </div>
    //         <input
    //           onBlur={(e) => handleSubmitScore(e)}
    //           type="number"
    //           onChange={(e) => {
    //             let value = e.target.value;
    //             if (/^\d*$/.test(value) || value === "") {
    //               const maxValue =
    //                 parseInt(response?.question?.correct_score) || 0;
    //               if (value === "" || parseInt(value) <= maxValue) {
    //                 setInputValue((prev) => ({
    //                   ...prev,
    //                   score: Number(value),
    //                 }))
    //               } else {
    //                 setInputValue((prev) => ({
    //                   ...prev,
    //                   score: Number(maxValue),
    //                 }))

    //               }
    //             }
    //             // setInputValue((prev) => ({
    //             //   ...prev,
    //             //   score: Number(e.target.value),
    //             // }))
    //           }
    //           }
    //           readOnly={studentResults?.length > 0}
    //           value={
    //             studentResults?.length > 0
    //               ? matchResultWithResponse()?.obtained_marks
    //               : score
    //           }
    //           className="score_box_hw px-2"
    //           placeholder="0 Score"
    //         />
    //       </div>
    //       {response?.question?.correct_answers?.length > 0 && (
    //         <>
    //           <div className="col-sm-6 mt-3 mb-1 review_remark_header_hw">
    //             Correct Answer:
    //           </div>
    //           {response?.question?.correct_answers?.map((cAnswer, index) => (
    //             <div key={index} className=" review_corect_ans_hw ">
    //               {cAnswer?.reason_for_answer?.explanation
    //                 ? cAnswer?.reason_for_answer?.explanation
    //                 : cAnswer?.value}
    //             </div>
    //           ))}
    //         </>
    //       )}
    //     </div>
    //   </div>
    // </div>

    <Paper
      elevation={0}
      sx={{
        mt: 1,
        p: 2.5,
        borderRadius: 3,
        border: "1px solid #f1c27d",
      }}
    >
      {/* QUESTION HEADER */}
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Box
          sx={{
            fontWeight: 700,
            color: "#8D4B28",
            minWidth: "32px",
          }}
        >
          Q{questionNumber + 1}.
        </Box>

        <Box>
          <Typography
            variant="body1"
            fontWeight={600}
            color="#1f2937"
            lineHeight={1.6}
          >
            {response?.question?.title?.split("\n").map((line, index) => (
              <span key={index}>
                {index !== 0 && <br />}
                {line}
              </span>
            ))}
            {response?.question?.is_mandatory === "true" && (
              <span style={{ color: "brown", marginLeft: "6px" }}>
                *mandatory
              </span>
            )}
          </Typography>
        </Box>
      </Stack>

      {/* QUESTION ATTACHMENTS */}
      {response?.question?.attachments?.length > 0 && (
        <Stack direction="row" spacing={2} mt={2} ml={4}>
          {response?.question?.attachments.map((obj, index) => (
            <AttachmentDefault
              key={index}
              attach={obj}
              className="ansAttach"
              fileSize={response?.question?.attachments_sizeKb[index]}
            />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 2 }} />

      {/* OPTIONS */}
      <Stack spacing={1.5} ml={4}>
        {response?.question?.options.map((option, index) => {
          const isCorrect = checkCorrectAnswer(option?.key);
          const isStudent = checkStudentAnswer(option?.key);

          return (
            <Box
              key={index}
              sx={{
                p: 1.5,
                borderRadius: 2,
                border: "1px solid",
                borderColor: isCorrect
                  ? "#16a34a"
                  : isStudent
                    ? "#dc2626"
                    : "#e5e7eb",
                backgroundColor: isCorrect
                  ? "#ecfdf5"
                  : isStudent
                    ? "#fef2f2"
                    : "#ffffff",
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <input
                  type="checkbox"
                  readOnly
                  checked={isCorrect || isStudent}
                  className={
                    isCorrect
                      ? "response_green_checkbox"
                      : "response_red_checkbox"
                  }
                />

                <Typography variant="body2" fontWeight={500}>
                  {option?.key}. {option?.value}
                </Typography>

                {isCorrect && (
                  <Chip
                    size="small"
                    label="Correct Answer"
                    sx={{
                      ml: "auto",
                      backgroundColor: "#16a34a",
                      color: "#fff",
                    }}
                  />
                )}

                {isStudent && (
                  <Chip
                    size="small"
                    label="Student Answer"
                    sx={{
                      ml: "auto",
                      backgroundColor: isCorrect ? "#16a34a" : "#dc2626",
                      color: "#fff",
                    }}
                  />
                )}
              </Stack>
              {/* OPTION IMAGE */}
              {/* {option.attachment &&
                (() => {
                  const ext = option.attachment.split(".").pop().toLowerCase();
                  const isImage = ["jpg", "jpeg", "png"].includes(ext);
                  return isImage ? (
                    <Box mt={1} ml={4}>
                      <ZoomableImage src={option.attachment} />
                    </Box>
                  ) : null;
                })()} */}
              {option.attachment && (() => {
                const fileUrl =
                  typeof option.attachment === "string"
                    ? option.attachment
                    : option.attachment?.url;

                if (!fileUrl) return null;

                const fileType = fileUrl.split(".").pop().toLowerCase();
                const isImage = ["jpg", "jpeg", "png"].includes(fileType);
                const isVideo = ["mp4", "mov"].includes(fileType);
                const isPdf = fileType === "pdf";

                const fileIcon =
                  iconData?.find((i) => i.extension === fileType)?.icon ||
                  "/images/file_icon.png";

                const fullUrl = fileUrl.startsWith("http")
                  ? fileUrl
                  : `${IP}${fileUrl}`;

                return (
                  <div className="d-flex flex-row align-items-center me-3">
                    {/* ===== Preview ===== */}
                    {isImage ? (
                      <Box mt={1} ml={4}>
                        <ZoomableImage src={option.attachment} />
                      </Box>
                    ) : isVideo ? (
                      <video
                        src={fullUrl}
                        style={{
                          width: "60px",
                          height: "50px",
                          borderRadius: "6px",
                          marginBottom: "5px",
                        }}
                        controls
                      />
                    ) : isPdf ? (
                      <div
                        onClick={() => handleClickforpdf(fileUrl)}
                        style={{
                          width: "100px",
                          height: "50px",
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={fileIcon}
                          alt="pdf"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <div className="hw_default_attach_name">
                          <span>
                            {option.attachment?.replace(/^[^_]*_/, "")}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <a
                        href={`https://docs.google.com/gview?url=${encodeURIComponent(
                          fullUrl
                        )}&embedded=true`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          style={{
                            width: "100px",
                            height: "50px",
                            background: "#f5f5f5",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={fileIcon}
                            alt="file"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </div>
                      </a>
                    )}
                  </div>
                );
              })()}
            </Box>
          );
        })}
      </Stack>

      {/* ANSWER STATUS */}
      <Box mt={2} ml={4}>
        {response?.answer?.key === " " ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <img src="/images/wrong_icon.svg" alt="" />
            <Typography fontWeight={600} color="#dc2626">
              Student Not Answered
            </Typography>
          </Stack>
        ) : (
          isRightAnswer && (
            <Stack direction="row" spacing={1} alignItems="center">
              <img src="/images/wrong_icon.svg" alt="" />
              <Typography fontWeight={600} color="#dc2626">
                Wrong
              </Typography>
            </Stack>
          )
        )}
      </Box>

      {/* TEACHER REMARK */}
      <Box mt={3}>
        <Typography fontWeight={600} mb={1}>
          Teacher Comment
        </Typography>

        <textarea
          onBlur={handleSubmitRemark}
          onChange={(e) =>
            setInputValue((prev) => ({ ...prev, remark: e.target.value }))
          }
          readOnly={studentResults?.length > 0}
          maxLength={250}
          className="remark_textfield_box_hw"
          value={
            studentResults?.length > 0
              ? matchResultWithResponse()?.comment
              : remark
          }
        />

        <Stack direction="row" spacing={2} mt={2} alignItems="center">
          <Typography>
            Allot marks out of {response?.question?.correct_score}
          </Typography>

          <input
            type="number"
            onBlur={handleSubmitScore}
            readOnly={studentResults?.length > 0}
            value={
              studentResults?.length > 0
                ? matchResultWithResponse()?.obtained_marks
                : score
            }
            className="score_box_hw px-2"
          />
        </Stack>

        {/* CORRECT ANSWER EXPLANATION */}
        {response?.question?.correct_answers?.length > 0 && (
          <>
            <Typography fontWeight={600} mt={3}>
              Correct Answer
            </Typography>

            {response?.question?.correct_answers.map((cAnswer, index) => (
              <Box
                key={index}
                sx={{
                  mt: 1,
                  p: 1.5,
                  borderRadius: 2,
                  backgroundColor: "#f0fdf4",
                  border: "1px solid #16a34a",
                }}
              >
                {cAnswer?.reason_for_answer?.explanation || cAnswer?.value}
              </Box>
            ))}
          </>
        )}
      </Box>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
    </Paper>
  );
};
export default McqQuestion;
